module.exports = "<app-conversion-rate-master [type]=\"type\"></app-conversion-rate-master>"